import { Button } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledSkus = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1rem;
`

export const Title = styled.div`
  white-space: nowrap;
  font-weight: 500;
`

export const Skus = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const SkuButton = styled(Button).attrs({ variant: "emptyOverGray" })``
